import { useNavigate } from "react-router-dom";
import { useTranslation } from "../i18n/LanguageContext";

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-900 p-6 text-center">
      <div className="bg-slate-800/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 w-full max-w-md border border-slate-700/50">
        <h1 className="text-6xl font-bold text-white mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-white mb-3">
          {t("notFound.heading", "Page not found")}
        </h2>
        <p className="text-gray-300 mb-6">
          {t("notFound.message", "The page you're looking for doesn't exist or has moved.")}
        </p>
        <button
          onClick={() => navigate("/")}
          className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-3 rounded-lg font-semibold hover:from-blue-500 hover:to-indigo-500 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
        >
          🎉 {t("notFound.backHome", "Back to Events")}
        </button>
      </div>
    </div>
  );
}

export default NotFound;
